import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { HttpService } from './../services/http.service';
import { FilterResponseModel } from '../models/filter/filter-response.model';

@Injectable({
  providedIn: 'root'
})

export class GlobalService {

  @Output() renderRibbon: EventEmitter<number> = new EventEmitter();
  authCode: any;
  loggedInUser;
  subscription: string;
  environment: string;
  tagMovMsg;
  constructor(public httpClient: HttpClient, public dialog: MatDialog) { }
  isAuthorize: boolean = false;
  isActivate: boolean = true;
  userDetails: any;
  
  showAlert(model, data) {
    this.dialog.open(model, {
      width: '450px',
      panelClass: 'confirm-modalbox-dark',
      height: 'auto',
      data: data
    });
  }

  showAlertWithCallBack(model, data, methodRef: (thisRef: any) => void, thisRef) {
    const dialogRef = this.dialog.open(model, {
      width: '450px',
      panelClass: 'confirm-modalbox-dark',
      height: 'auto',
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result && result != null){
        methodRef(thisRef);
      }
    });
  }

  openModelWindow(methodRef: (thisRef: any, result?: any) => void, thisRef, modelComponent, widthOfWindow, panelClassName, dataToPass) {
    {
      const dialogRef = this.dialog.open(modelComponent, {
        width: widthOfWindow,
        panelClass: panelClassName,
        data: dataToPass
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result === true && methodRef != null) {
          methodRef(thisRef);
        }
        else if (result !== false && result !== undefined) {
          methodRef(thisRef, result);
        }
      });
    }
  }
  /**
   * Checks if the given string parameter is not undefined, null or empty.
   * @param data string to be checked
   */
  isNotNull(data: string) {
    let response: boolean = false;
    if (data != undefined && data != null && data != "") {
      response = true;
    }
    return response;
  }

  /**
   * Replaces display text for filter
   * @param tempText
   */
  replaceDisplayText(tempText: string) {
    if (tempText == "flowSheetName") {
      return "Flowsheet Name";
    } else if (tempText == "flowSheetDescription") {
      return "Description";
    } else if (tempText == "lastUpdatedTimeStamp") {
      return "Last Modified At";
    } else if (tempText == "lastUpdatedBy") {
      return "Last Modified By";
    } 
  }

  /**
   * Replace filter texts
   * @param tempText
   */
  replaceFilterText(tempText: string): string {
    if (tempText == "Flowsheet Name") {
      return "flowSheetName";
    } else if (tempText == "Description") {
      return "flowSheetDescription";
    } else if (tempText == "Last Modified By") {
      return "lastUpdatedBy";
    } else if (tempText == "Last Modified At") {
      return "lastUpdatedTimeStamp";
    } else {
      return "";
    }
  }

  /**
   * Filters data
   * @param filterResponse
   */
  conditionalDataFiltering(filterResponse: FilterResponseModel, data) {
    let temp;
    if (filterResponse.selectedValue.length == 1) {
      temp = data.filter(function (df) {
        return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]);
      });
    } else if (filterResponse.selectedValue.length == 2) {
      temp =  data.filter(function (df) {
          return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[1]);
          });
    } else if (filterResponse.selectedValue.length == 3) {
      temp = data.filter(function (df) {
        return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[1])
          || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[2]);
      });
    } else if (filterResponse.selectedValue.length == 4) {
      temp = data.filter(function (df) {
        return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[1])
          || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[2]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[3]);
      });
    } else if (filterResponse.selectedValue.length == 5) {
      temp = data.filter(function (df) {
        return (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[0]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[1])
          || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[2]) || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[3])
          || (df[filterResponse.selectedFieldName] === filterResponse.selectedValue[4]);
      });
    }
    return temp;
  }
}
